import { Breadcrumb, Button, Col, DatePicker, Empty, Form, Input, message, Modal, Popover, Row, Select, Space, Spin, Table, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useReducer, useState } from 'react';
import {  HomeOutlined, EyeOutlined, FileTextOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useAuth } from '../../Context';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import moment from 'moment';
import axios from 'axios';
import vspSurveyReducer from './reducer';
import { VSP_INVERSION_LIST, VSP_INVERSION_LIST_ERROR, VSP_INVERSION_LIST_SUCCESS } from './constants';

const { Title } = Typography;
const { RangePicker } = DatePicker;


// function generateSyntheticSeismicData(rows = 100, cols = 100) {
// 	const x = Array.from({ length: cols }, (_, i) => (i / (cols - 1)).toFixed(2)); // distance
// 	const y = Array.from({ length: rows }, (_, i) => (i / (rows - 1)).toFixed(2)); // depth

// 	const z = [];

// 	const frequency = 5; // Controls how many bars appear
// 	const amplitude = 2.0;
// 	const base = 3.0;

// 	for (let i = 0; i < rows; i++) {
// 		const barValue = Math.sin((i / rows) * Math.PI * frequency) * amplitude + base;
// 		const row = Array.from({ length: cols }, () => Number(barValue.toFixed(3)));
// 		z.push(row);
// 	}

// 	return { x, y, z };

// }

// const unpack = (rows, key) => rows.map(row => row[key]);

export default function VSPSurveyInversion () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	// const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const initalState = {vspInversionData:[], plotInversionData: [], loading: false, error: false, updateData : {} };
	const [data, dispatch] = useReducer(vspSurveyReducer, initalState);

	const { state } = useLocation();
	const navigate = useNavigate();

	// const [spin, setSpin] = useState(false);

	const [startDate, setStartDate] = useState(state && state.data && state.data.startDate ? state.data.startDate: moment.utc(new Date().setHours(0,0,0,0)).subtract({'days' : 30}).toISOString());
	const [endDate, setEndDate] = useState(state && state.data && state.data.endDate ? state.data.endDate: new Date().toISOString());

	const [wellFieldId, setwellFieldId] = useState(state && state.data && state.data.wellFieldId ? state.data.wellFieldId : null);
    
	const [openvelocitiesDetails, setOpenVelocitiesDetails] = useState(false);
	const [velocitiesDetailViewValues, setvelocitiesDetailViewValues] = useState([{ layers: '', depths: '', velocities: '', offsets: '' }]);
	const [suveyseriesId, setSurveySeriesId] = useState(null);
	

	const { wellFieldinfo, getWellFieldsInfo, surveySeriesinfo, getSurveySeriesInfo} = useAuth();

	const wellFieldFilterData = [];
	wellFieldFilterData.push({
		value : null,
		label : 'ALL'
	});
	const wellFieldData = [];
	wellFieldinfo && wellFieldinfo.map((item) => {
		wellFieldFilterData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		wellFieldData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
	});


	const suveySeriesDataFilter =[];
	suveySeriesDataFilter.push({
		value : null,
		label : 'ALL'
	});

	const suveySeriesData = [];
	surveySeriesinfo && surveySeriesinfo.map((item) => {

		suveySeriesDataFilter.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		suveySeriesData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		
	});
	
	useEffect(() => {
		loadVSPInversionData();		
	},[wellFieldId, startDate, endDate, suveyseriesId]);
	
	const loadVSPInversionData = () => {
		dispatch({ type : VSP_INVERSION_LIST });
		let params = '';
		if(wellFieldId) {
			params += `&wellFieldId=${wellFieldId}`;
		}
		if (suveyseriesId){
			params += `&seriesId=${suveyseriesId}`;
		}
			
		// if(startDate && endDate){
		// 	params += `&datetime[$gte]=${startDate}&datetime[$lte]=${endDate}`;
		// }
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:  `${api}/inversionproperties?$sort[id]=1${params}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : VSP_INVERSION_LIST_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : VSP_INVERSION_LIST_ERROR });
				}
			})
			.catch((error) => {
				dispatch({ type : VSP_INVERSION_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	

	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getSurveySeriesInfo(authtoken, null);

	},[]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const handleSetWellField = (value) => {
		setwellFieldId(value);
	};

	const disabledRangeTime = (currentDate) => {
		if (!currentDate) {
			return {};
		}
		
		const now = moment();
		
		// Disable future time slots on the current date
		if (currentDate.isSame(now, 'day')) {
			return {
				disabledHours: () => {
					const currentHour = now.hour();
					// Disable hours after the current hour
					return Array.from({ length: 24 }, (_, i) => (i > currentHour ? i : null)).filter(i => i !== null);
				},
				// disabledMinutes: () => {
				// 	const currentHour = now.hour();
				// 	const currentMinute = now.minute();
				// 	// Disable minutes after the current minute in the current hour
				// 	if (currentHour === now.hour()) {
				// 		return Array.from({ length: 60 }, (_, i) => (i > currentMinute ? i : null)).filter(i => i !== null);
				// 	}
				// 	return [];
				// },
				// disabledSeconds: () => {
				// 	const currentHour = now.hour();
				// 	const currentMinute = now.minute();
				// 	const currentSecond = now.second();
				// 	// Disable seconds after the current second in the current minute
				// 	if (currentHour === now.hour() && currentMinute === now.minute()) {
				// 		return Array.from({ length: 60 }, (_, i) => (i > currentSecond ? i : null)).filter(i => i !== null);
				// 	}
				// 	return [];
				// },
			};
		}
		
		// For future dates, allow all hours, minutes, and seconds
		return {};
	};

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};

	const handleSetDate = (e) =>{
		if(e) {
			setStartDate(moment.utc(new Date(e[0] && e[0].$d)).toISOString());
			setEndDate(moment.utc(new Date(e[1] && e[1].$d)).toISOString());  
		} else {
			setStartDate(null);
			setEndDate(null);
		}
	};


	const columns = [

		{
			title: `${langdata && langdata.FieldName ? langdata.FieldName:'Field Name'}`,
			dataIndex: 'wellfields',
			key: 'wellfields',
		},
		{
			title: `${langdata && langdata.DateTime ? langdata.DateTime:'Date Time'}`,
			dataIndex: 'datetime',
			key: 'datetime',
		},
		{
			title: `${langdata && langdata.SurveySeries ? langdata.SurveySeries:'Survey Series'}`,
			dataIndex: 'surveySeries',
			key: 'surveySeries',
		},

		{
			title: `${langdata && langdata.Depthm ? langdata.Depthm:'Depth (m)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.Depthm ? langdata.Depthm:'Depth (m)'}
					content={Array.isArray(properties?.layerDepth) ? properties?.layerDepth.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.layerDepth) ?<a> {properties?.layerDepth.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.Pwavevelocityms ? langdata.Pwavevelocityms:'P-wave velocity (m/s)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.Pwavevelocityms ? langdata.Pwavevelocityms:'P-wave velocity (m/s)'}
					content={Array.isArray(properties?.Vp) ? properties?.Vp.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.Vp) ?<a> {properties?.Vp.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.Swavevelocityms ? langdata.Swavevelocityms:'S-wave velocity (m/s)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.Swavevelocityms ? langdata.Swavevelocityms:'S-wave velocity (m/s)'}
					content={Array.isArray(properties?.Vs) ? properties?.Vs.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.Vs) ?<a> {properties?.Vs.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.Density ? langdata.Density:'Density (kg/m³)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.Density ? langdata.Density : 'Density (kg/m³)'}
					content={Array.isArray(properties?.density) ? properties?.density.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.density) ?<a> {properties?.density.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},


		{
			title: `${langdata && langdata.Porosity ? langdata.Porosity:'Porosity'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.Porosity ? langdata.Porosity:'Porosity'}
					content={Array.isArray(properties?.porosity) ? properties?.porosity.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.porosity) ?<a> {properties?.porosity.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.LamesConstantPa ? langdata.LamesConstantPa:'Lames Constant (Pa)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.LamesConstantPa ? langdata.LamesConstantPa:'Lames Constant (Pa)'}
					content={Array.isArray(properties?.lameLambda) ? properties?.lameLambda.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.lameLambda) ?<a> {properties?.lameLambda.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.BulkModulusPa ? langdata.BulkModulusPa:'Bulk Modulus (Pa)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.BulkModulusPa ? langdata.BulkModulusPa:'Bulk Modulus (Pa)'}
					content={Array.isArray(properties?.bulkModulus) ? properties?.bulkModulus.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.bulkModulus) ?<a> {properties?.bulkModulus.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},


		{
			title: `${langdata && langdata.PoissonsRatio ? langdata.PoissonsRatio:'Poissons Ratio'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.PoissonsRatio ? langdata.PoissonsRatio:'Poissons Ratio'}
					content={Array.isArray(properties?.poissonRatio) ? properties?.poissonRatio.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.poissonRatio) ?<a> {properties?.poissonRatio.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.PwaveModulusPa ? langdata.PwaveModulusPa:'Pwave Modulus (Pa)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.PwaveModulusPa ? langdata.PwaveModulusPa:'Pwave Modulus (Pa)'}
					content={Array.isArray(properties?.pwaveModulus) ? properties?.pwaveModulus.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.pwaveModulus) ?<a> {properties?.pwaveModulus.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},


		{
			title: `${langdata && langdata.ShearModulusPa ? langdata.ShearModulusPa:'Shear Modulus (Pa)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.ShearModulusPa ? langdata.ShearModulusPa:'Shear Modulus (Pa)'}
					content={Array.isArray(properties?.shearModulus) ? properties?.shearModulus.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.shearModulus) ?<a> {properties?.shearModulus.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.YoungsModulusPa ? langdata.YoungsModulusPa:'Youngs Modulus (Pa)'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.YoungsModulusPa ? langdata.YoungsModulusPa:'Youngs Modulus (Pa)'}
					content={Array.isArray(properties?.youngsModulus) ? properties?.youngsModulus.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.youngsModulus) ?<a> {properties?.youngsModulus.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},


		{
			title: `${langdata && langdata.AcousticImpedance ? langdata.AcousticImpedance:'Acoustic Impedance (kg/(m²·s))'}`,
			dataIndex: 'properties',
			key: 'properties',
			render: (properties, options) => (	
							
				<Popover
					title={langdata && langdata.AcousticImpedance ? langdata.AcousticImpedance:'Acoustic Impedance (kg/(m²·s))'}
					content={Array.isArray(properties?.acousticImpedance) ? properties?.acousticImpedance.join(', ') : 'Nill'}
					trigger="hover"
				>
					<Typography.Paragraph
						ellipsis={{
							rows: 2,
							expandable: false,
							symbol: ''
						}}
						style={{ marginBottom: 0 }}
						onClick={()=>{handleOpenDetails(options);}}
					>
						{Array.isArray(properties?.acousticImpedance) ?<a> {properties?.acousticImpedance.join(', ')} </a>: 'Nill'}
					</Typography.Paragraph>
				</Popover>
			),
		},

		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'action',
			align:'center',
			render: (_,record) => (
				<Space style={{justifyContent:'center',display:'flex'}} size="middle">
					<Button title={langdata && langdata.View ? langdata.View:'View'} type='link' onClick={() => {handleInversiondata(record);}}><EyeOutlined/></Button>
				</Space>
			)
		}
    
	];

	const handleInversiondata = (record) =>{
		
		const id = [record.id];
		
		navigate(( '/vsp-survey-inversion-graph'),{ state: { data: {id : id, wellFieldId: record.wellFieldId, seriesId: record.seriesId}, path: 'vsp-survey-inversion' } });
		
	};

	const handleOpenDetails = (value) =>{		

		setOpenVelocitiesDetails(true);

		const depths = value?.properties?.layerDepth || [];

		const pv = value?.properties?.Vp || [];
		const sv = value?.properties?.Vs || [];
		const density = value?.properties?.density || [];
		const porosity = value?.properties?.porosity || [];
		const lameLambda = value?.properties?.lameLambda || [];
		const bulkmoduls = value?.properties?.bulkModulus || [];
		const poissonsratio = value?.properties?.poissonRatio || [];
		const pwmoduls = value?.properties?.pwaveModulus || [];
		const shearmoduls = value?.properties?.shearModulus || [];
		const youngsmoduls =  value?.properties?.youngsModulus || [];
		const acousticsimpedence =  value?.properties?.acousticImpedance || [];
		
		const result = depths.map((startValue, idx) => ({
			depths: startValue,

			pv: pv[idx],
			sv: sv[idx],
			density: density[idx],
			porosity: porosity[idx],
			lameLambda: lameLambda[idx],
			bulkmoduls: bulkmoduls[idx],
			poissonsratio: poissonsratio[idx],
			pwmoduls: pwmoduls[idx],
			shearmoduls: shearmoduls[idx],
			youngsmoduls: youngsmoduls[idx],
			acousticsimpedence: acousticsimpedence[idx]

		}));
		setvelocitiesDetailViewValues(result);


	};

	const handleSetSurveySeries = (e) =>{
		setSurveySeriesId(e);
	};

	const handleCancel = () => {
		setOpenVelocitiesDetails(false);
		
	};

	const handleInversionImagingdata = () =>{
		
		let intensity = [0, 0.14285714285714285, 0.2857142857142857, 0.42857142857142855, 0.5714285714285714, 0.7142857142857143, 0.8571428571428571, 1];

		const cubedata = {

			x : [0, 10, 10, 0, 0, 10, 10, 0], // x extended from 5 to 10
			y : [0, 0, 1, 1, 0, 0, 1, 1],    // same in y (depth)
			z : [0, 0, 0, 0, 1, 1, 1, 1],    // same in z (height)

			i : [7, 0, 0, 0, 4, 4, 2, 6, 4, 0, 3, 7],
			j : [3, 4, 1, 2, 5, 6, 5, 5, 0, 1, 2, 2],
			k : [0, 7, 2, 3, 6, 7, 1, 2, 5, 5, 7, 6],

			intensity: intensity
		};


		let a=[]; let b=[]; let c=[];
		for(let i=0;i<50;i++)
		{
			let a_ = Math.random(); 
			a.push(a_);
    
			let b_ = Math.random(); 
			b.push(b_);
    
			let c_ = Math.random(); 
			c.push(c_);
		}

		const meshdata = {

			x : a, 
			y : b, 
			z : c,
		};



		navigate(( '/vsp-survey-inversion-imaging'),{ state: { data: {cubedata:cubedata, meshdata:meshdata}, path: 'vsp-survey-inversion' } });

	};

	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >

					<Col span={6}>
						<Row>
							<Space>
								<FileTextOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							{/* <Col style={{marginLeft:'4px'}} span={19}> */}
							<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.Inversion ? langdata.Inversion : 'Inversion'}</Title>
							<Space>&nbsp;&nbsp;</Space>
						</Row>
					</Col>
					<Col span={18}>
						<Row justify="end">
							<Col>
								{/* <Tooltip placement="bottom" title={langdata && langdata.FilterbyWell ? langdata.FilterbyWell : 'Filter by well'}>
									<Space>
										<Select
											style={{minWidth: '150px', maxWidth:'150px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.SelectWell ? langdata.SelectWell : 'Select Well'}
											optionFilterProp="children"
											value={wellId}
											options={welldata}
											onSelect={(e, options)=>handleSetWell(e, options)}
										/>
									</Space>
								</Tooltip>
								<Space>&nbsp;</Space>	
								<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel : 'Filter by channel'}>
									<Select
										style={{ minWidth: '150px', maxWidth:'150px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectChannel ? langdata.SelectChannel : 'Select Channel'}
										optionFilterProp="children"
										defaultValuevalue={null}
										value={channelId}
										options={channellist}
										onSelect={(value)=>handleSetChannel(value)}
									/>
								</Tooltip>
								<Space>&nbsp;</Space> */}
								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthedateandtime ? langdata.Pleaseselectthedateandtime :'Please select the date and time'}>
									<RangePicker 
										showTime ={{hideDisabledOptions: true, format : 'YYYY-MM-DD HH'}} 
										style={{ width: '300px',margin:'5px'}}
										defaultValue={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
										format={settingsdateformat + ' ' + settingstimeformat}
										placeholder={[langdata && langdata.Startdateandtime ? langdata.Startdateandtime : 'Start date and time', langdata && langdata.Enddateandtime ? langdata.Enddateandtime : 'End date and time']}
										disabledDate={disabledDate}
										disabledTime={disabledRangeTime}
										onChange={handleSetDate}
										allowClear={true} />
								</Tooltip>
								<Space>&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield :'Please select the well field'}>
									<Select
										style={{ minWidth: '150px', maxWidth:'150px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.FieldName ? langdata.FieldName : 'Field Name'}
										optionFilterProp="children"
										defaultValuevalue={null}
										value={wellFieldId}
										options={wellFieldFilterData}
										onSelect={(value)=>handleSetWellField(value)}
									/>
								</Tooltip>
								<Space>&nbsp;</Space>

								<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}>
									<Space>
										<Select
											style={{ width: '180px', margin:'5px'}}
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}
											optionFilterProp="children"
											value={suveyseriesId}
											options={suveySeriesDataFilter}
											onSelect={(e, options)=>handleSetSurveySeries(e, options)}
										/>
									</Space>
								</Tooltip>

								<Space>&nbsp;</Space>
								<Tooltip placement="bottom" title={langdata && langdata.Imaging ? langdata.Imaging:'Imaging'}>
									<Button
										style={{ margin:'5px' }}
										type='primary'
										onClick={handleInversionImagingdata}
									>{langdata && langdata.Imaging ? langdata.Imaging:'Imaging'}</Button>
								</Tooltip>					
							</Col>
						</Row>
					</Col>
				</Row>
				<Row style={{
					margin: '10px',
					// marginTop : '5px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// background: '#FFFFFF',
					alignItems:'center',
				}}  >
					<Col>
						<Breadcrumb
							items={[
								{
									href: '/dashboard',
									title: <HomeOutlined />,
								},
								{
									title: ( state && state?.path === 'well-visualization' ? <a onClick={()=>{navigate(-3);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a> :  <a onClick={()=>{navigate(-3);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>)
								},
								{
									title: ( state && state?.path === 'vsp-survey' ? <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a> :  <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a>)
								},

								{
									title: ( state && state?.path === 'vsp-survey-details' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a>)
								},
								{
									title: `${langdata && langdata.Inversion ? langdata.Inversion : 'Inversion'}`,
								},

							]}
							// style={{ marginBottom : '10px'}}
						/>
					</Col>
				</Row>

				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{data.vspInversionData.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.vspInversionData}/>
							: 
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)
						}
					</Col>
				</Row>
				
			</Content>
			
			<Modal
				title={langdata && langdata.Details ? langdata.Details : 'Details'}
				centered
				open={openvelocitiesDetails}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
					</Space>
				]}
				width={1600}
			>

				<Form layout="vertical" >

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Details ? langdata.Details:'Details'}</b></Typography>
						</Col>
					</Row>

					{velocitiesDetailViewValues.map((input, index) => (						
						
						<Row gutter={24} key={index}>
							
							<Col span={2}>
								<Tooltip title={input.depths && input.depths !== '' ? input.depths : null}>

									<Form.Item
										label={ <Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata?.Depthm || 'Depth (m)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata?.Pleaseselectthedepth || 'Please select the depth'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.depths && input.depths !== '' ? input.depths : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.pv && input.pv !== '' ? input.pv : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.Pwavevelocityms ? langdata.Pwavevelocityms:'P-wave velocity (m/s)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.Pwavevelocityms ? langdata.Pwavevelocityms:'P-wave velocity (m/s)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.pv && input.pv !== '' ? input.pv : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.sv && input.sv !== '' ? input.sv : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.Swavevelocityms ? langdata.Swavevelocityms:'S-wave velocity (m/s)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.Swavevelocityms ? langdata.Swavevelocityms:'S-wave velocity (m/s)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.sv && input.sv !== '' ? input.sv : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.density && input.density !== '' ? input.density : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.Density ? langdata.Density:'Density (kg/m³)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.Density ? langdata.Density:'Density (kg/m³)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.density && input.density !== '' ? input.density : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.porosity && input.porosity !== '' ? input.porosity : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.Porosity ? langdata.Porosity:'Porosity' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.Porosity ? langdata.Porosity:'Porosity'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.porosity && input.porosity !== '' ? input.porosity : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.lameLambda && input.lameLambda !== '' ? input.lameLambda : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.LamesConstantPa ? langdata.LamesConstantPa:'Lames Constant (Pa)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.LamesConstantPa ? langdata.LamesConstantPa:'Lames Constant (Pa)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.lameLambda && input.lameLambda !== '' ? input.lameLambda : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.bulkmoduls && input.bulkmoduls !== '' ? input.bulkmoduls : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.BulkModulusPa ? langdata.BulkModulusPa:'Bulk Modulus (Pa)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.BulkModulusPa ? langdata.BulkModulusPa:'Bulk Modulus (Pa)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.bulkmoduls && input.bulkmoduls !== '' ? input.bulkmoduls : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.poissonsratio && input.poissonsratio !== '' ? input.poissonsratio : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.PoissonsRatio ? langdata.PoissonsRatio:'Poissons Ratio' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.PoissonsRatio ? langdata.PoissonsRatio:'Poissons Ratio'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.poissonsratio && input.poissonsratio !== '' ? input.poissonsratio : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.pwmoduls && input.pwmoduls !== '' ? input.pwmoduls : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.PwaveModulusPa ? langdata.PwaveModulusPa:'P-wave Modulus (Pa)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.PwaveModulusPa ? langdata.PwaveModulusPa:'P-wave Modulus (Pa)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.pwmoduls && input.pwmoduls !== '' ? input.pwmoduls : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.shearmoduls && input.shearmoduls !== '' ? input.shearmoduls : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.ShearModulusPa ? langdata.ShearModulusPa:'Shear Modulus (Pa)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.ShearModulusPa ? langdata.ShearModulusPa:'Shear Modulus (Pa)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.shearmoduls && input.shearmoduls !== '' ? input.shearmoduls : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.youngsmoduls && input.youngsmoduls !== '' ? input.youngsmoduls : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.YoungsModulusPa ? langdata.YoungsModulusPa:'Youngs Modulus (Pa)' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.YoungsModulusPa ? langdata.YoungsModulusPa:'Youngs Modulus (Pa)'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.youngsmoduls && input.youngsmoduls !== '' ? input.youngsmoduls : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>

							<Col span={2}>
								<Tooltip title={input.acousticsimpedence && input.acousticsimpedence !== '' ? input.acousticsimpedence : null}>
									<Form.Item
										label={<Typography style={{minHeight:index == 0 ? '70px' : ''}}> {index == 0 ? langdata && langdata.Acousticimpedance ? langdata.Acousticimpedance:'Acoustic Impedance' : ''}</Typography>}
									
									>
										{/* <Input
										placeholder={langdata?.Pleaseselecttheendchainage || 'Please select the end chainage'}
										value={input.End}
										onChange={e => handleChangeSuppression(index, 'End', e.target.value)}
									/> */}
										<Input
											style={{ minWidth: '100px', margin:'5px'}}
											type='number'
											min={0}
											// showSearch
											// filterOption={filterOption}
											placeholder={langdata && langdata.AcousticImpedance ? langdata.AcousticImpedance:'Acoustic Impedance (kg/(m²·s))'}
											// optionFilterProp="children"
											// options={pipelineChainage}
											disabled
											value={input.acousticsimpedence && input.acousticsimpedence !== '' ? input.acousticsimpedence : null}
										// value={input.End}
										// onChange={e => handleChangeSuppression(index, 'depths', e)}
										/>
									</Form.Item>
								</Tooltip>
							</Col>
							
						</Row>
							
					))}
				</Form>
			</Modal>

			<Spin fullscreen spinning={false} />

			{/* Add Vulnerable Point Details Modal Starts */}
			
			{/* Delete User Modal Ends */}
		</>
	);
}